import EntityCrudPage from '../../shared/EntityCrudPage';
import { changeManagementConfig } from '../../config/entityConfigs';

const ChangeManagementsPage = () => (
  <EntityCrudPage
    config={changeManagementConfig}
    subtitle="All change management records across software systems"
  />
);

export default ChangeManagementsPage;
